import React, { useState, useEffect } from "react";
import { db } from "../../db/firebaseConfig";
import { collection, addDoc, getDocs } from "firebase/firestore";

export default function AgregarProducto() {
  const [formData, setFormData] = useState({
    name: "",
    category: "",
    subcategory: "",
    description:"",
    price: "",
    stock: "",
    img: "",
    
  });

  const [mensaje, setMensaje] = useState("");
  const [categorias, setCategorias] = useState([]);
  const [subcategorias, setSubcategorias] = useState([]);

  // Traer categorías y subcategorías desde los productos existentes
  useEffect(() => {
    const fetchCategorias = async () => {
      const colRef = collection(db, "producto");
      const snapshot = await getDocs(colRef);
      const products = snapshot.docs.map(doc => doc.data());

      // Categorías únicas
      const cats = [...new Set(products.map(p => p.category))];
      setCategorias(cats);

      // Subcategorías únicas
      const subs = [...new Set(products.map(p => p.subcategory))];
      setSubcategorias(subs);
    };

    fetchCategorias();
  }, []);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
  e.preventDefault();

  // 🔹 Limpiar el precio: quitar puntos y comas de miles
  const priceClean = formData.price.replace(/\./g, "").replace(/,/g, "");

  try {
    await addDoc(collection(db, "producto"), {
      name: formData.name,
      category: formData.category,
      subcategory: formData.subcategory,
      description: formData.description || "",
      price: parseFloat(priceClean), // ✅ se guarda como número limpio (ej: 6200)
      stock: parseInt(formData.stock),
      img: formData.img,
    });

    setMensaje("✅ Producto agregado con éxito");
    setFormData({
      name: "",
      category: "",
      subcategory: "",
      description: "",
      price: "",
      stock: "",
      img: "",
    });

    setTimeout(() => setMensaje(""), 3000);
  } catch (error) {
    console.error("Error agregando producto:", error);
    setMensaje("❌ Hubo un error al agregar el producto");
  }
};


  return (
    <div className="bg-white p-6 rounded-lg shadow-md">
      <h3 className="text-2xl font-bold mb-4">➕ Agregar Producto</h3>

      <form onSubmit={handleSubmit} className="flex flex-col gap-4">
        <input
          type="text"
          name="name"
          placeholder="Nombre del producto"
          value={formData.name}
          onChange={handleChange}
          className="border p-2 rounded"
          required
        />

        <select
          name="category"
          value={formData.category}
          onChange={handleChange}
          className="border p-2 rounded"
          required
        >
          <option value="">Seleccionar categoría</option>
          {categorias.map((cat, i) => (
            <option key={i} value={cat}>
              {cat}
            </option>
          ))}
        </select>

        <select
          name="subcategory"
          value={formData.subcategory}
          onChange={handleChange}
          className="border p-2 rounded"
          required
        >
          <option value="">Seleccionar subcategoría</option>
          {subcategorias.map((sub, i) => (
            <option key={i} value={sub}>
              {sub}
            </option>
          ))}
        </select>
         <textarea
          name="description"
          placeholder="Descripción del producto"
          value={formData.description}
          onChange={handleChange}
          className="border p-2 rounded h-24"
          required
        />


        <input
          type="number"
          name="price"
          placeholder="Precio"
          value={formData.price}
          onChange={handleChange}
          className="border p-2 rounded"
          required
        />

        <input
          type="number"
          name="stock"
          placeholder="Stock inicial"
          value={formData.stock}
          onChange={handleChange}
          className="border p-2 rounded"
          required
        />

        <input
          type="text"
          name="img"
          placeholder="URL de imagen (opcional)"
          value={formData.img}
          onChange={handleChange}
          className="border p-2 rounded"
        />

        <button
          type="submit"
          className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
        >
          Guardar
        </button>
      </form>

      {mensaje && <p className="mt-4 text-center">{mensaje}</p>}
    </div>
  );
}
